<quick-dashboard
  [loader]="loader"
  [uid]="'rag-templates-dashboard'"
  [heading]="'Templates'"
  [columnOptions]="{
    '$$raw': { hidden: true },
    'id': { hidden: true },
    'assistantId': { heading: 'Assistant', order: 2, renderTemplate: cellAssistant },
    'name': { heading: 'Name', order: 1, renderTemplate: cellName },
    'description': { heading: 'Description', hidden: true },
    'messages': {
      heading: 'Messages',
      order: 4,
      renderTemplate: cellMessages,
      outerNgClass: 'align-middle cell-width-140'
    },
    'createdBy': { heading: 'Owner', order: 3, renderTemplate: cellCreatedBy },
    'actions': {
      heading: 'Actions',
      order: 60,
      renderTemplate: cellActions,
      outerNgClass: 'align-middle cell-width-180'
     }
  }"
  [hasRouterOutlet]="true"
>
</quick-dashboard>

<ng-template #cellName let-rowItem=rowItem>
  <div>
    <div>{{rowItem['name']}}</div>
    <div class="text-secondary fw-light font-size-14">{{rowItem['description']}}</div>
  </div>
</ng-template>

<ng-template #cellAssistant let-cellItem=cellItem>
  <chatbot-uid-tag
    [chatbotUuid]="cellItem"
  ></chatbot-uid-tag>
</ng-template>

<ng-template #cellCreatedBy let-cellItem=cellItem>
  <user-id-tag
    [userId]="cellItem"
  ></user-id-tag>
</ng-template>

<ng-template #cellMessages let-cellItem=cellItem>
  {{cellItem.length}}
</ng-template>


<ng-template #cellActions let-rowItem=rowItem>
  <div>
    <preview-button ngClass="ms-2" [routerLink]="['./preview', rowItem['id']]"></preview-button>
    <ng-container *ngIf="!roleCheckFailed">
      <manage-button
        [useLinkButton]="true"
        [ngClass]="'ms-1'"
        [routerLink]="['./manage', rowItem['id']]"
      ></manage-button>

      <a
        matTooltip="Clone this template"
        [ngClass]="'ms-2'"
        [routerLink]="['./manage']"
        [queryParams]="{
          'source': rowItem['id']
        }"
      >
        <mat-icon class="valign-middle">content_copy</mat-icon>
      </a>
      <delete-button
                     [useLinkButton]="true"
                     [disabled]="rowItem['isSystem']"
                     [ngClass]="'ms-1'"
                     [routerLink]="rowItem['isSystem'] ? [] : ['./delete', rowItem['id']]">
      </delete-button>
    </ng-container>
    <ng-container *ngIf="roleCheckFailed">
      <manage-button
        [matTooltip]="
          rowItem['isSystem'] || currentUser != rowItem['createdBy']
          ? 'This is a system entry or you are not its creator.'
          : 'Edit'"
        [disabled]="rowItem['isSystem'] || currentUser != rowItem['createdBy']"
        [useLinkButton]="true"
        [ngClass]="'ms-1'"
        [routerLink]="[rowItem['isSystem'] || currentUser != rowItem['createdBy'] ? [] : './manage', rowItem['id']]"
      ></manage-button>
      <a
        matTooltip="Clone this template"
        [ngClass]="'ms-2'"
        [routerLink]="['./manage']"
        [queryParams]="{
          'source': rowItem['id']
        }"
      >
        <mat-icon class="valign-middle">content_copy</mat-icon>
      </a>
      <delete-button
        [matTooltip]="
          rowItem['isSystem'] || currentUser != rowItem['createdBy']
          ? 'This is a system entry or you are not its creator.'
          : 'Delete'"
        [useLinkButton]="true"
        [disabled]="rowItem['isSystem'] || currentUser != rowItem['createdBy']"
        [ngClass]="'ms-1'"
        [routerLink]="rowItem['isSystem'] || currentUser != rowItem['createdBy'] ? [] : ['./delete', rowItem['id']]"
      ></delete-button>
    </ng-container>
  </div>
</ng-template>
